import React from 'react';

export default class DashboardIcon extends React.Component {
  render() {
    return(
      <svg height="100%" viewBox="-0.037 -0.58 19.147 17.496">
      <g>
        <path fill="#BD311F" d="M16.466,11.965c-0.864,0-1.648-0.701-1.648-1.565v-0.006c0-0.864,0.783-1.565,1.648-1.565h2.644V5.362
          c0-0.912-0.656-1.651-1.568-1.651H1.696c-0.912,0-1.733,0.739-1.733,1.651v9.904c0,0.912,0.822,1.651,1.733,1.651h15.846
          c0.912,0,1.568-0.739,1.568-1.651v-3.301H16.466z"/>
        <circle fill="#BD311F" cx="16.993" cy="10.397" r="0.64"/>
        <path fill="#BD311F" d="M11.124,2.371L9.981-0.422C9.955-0.485,9.905-0.535,9.842-0.561S9.708-0.586,9.646-0.559L3.17,2.234
          C3.06,2.282,2.998,2.401,3.022,2.519C3.046,2.637,3.15,2.721,3.271,2.721h7.618c0.085,0,0.164-0.042,0.211-0.112
          C11.147,2.539,11.156,2.45,11.124,2.371z"/>
      </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/WalletIcon.js